import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import Input from 'react-bootstrap-myui/lib/Input'

class Radiobox extends React.Component {
  static propTypes = {
    data: PropTypes.bool,
    name: PropTypes.string,
    onChange: PropTypes.func,
    radioName: PropTypes.array
  };

  constructor(props) {
    super(props)
    this.state = {
      checked: props.data || false
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.data, nextProps.data)) {
      this.setState({
        checked: nextProps.data || false
      })
    }
  }

  render() {
    const { checked } = this.state
    const { name, radioName } = this.props

    return (
      <div style={{ textAlign: 'left' }} className="checkbox-container">
        <div className={checked ? 'col-xs-6 radio-checked' : 'col-xs-6'}>
          <Input
            label={radioName[0] || '显示'}
            type="radio"
            name={ name || 'radio'}
            checked={checked}
            onClick={this.handleCheckChange.bind(this, !checked)}
            onChange={() => { }}
          />
        </div>
        <div className={!checked ? 'col-xs-6 radio-checked' : 'col-xs-6'}>
          <Input
            label={radioName[1] || '不显示'}
            type="radio"
            name={ name || 'radio'}
            checked={!checked}
            onClick={this.handleCheckChange.bind(this, !checked)}
            onChange={() => { }}
          />
        </div>
      </div>
    )
  }

  handleCheckChange(value) {
    this.setState({
      checked: value
    }, () => {
      this.props.onChange(value)
    })
  }
}

export default Radiobox
